import ajax from '@/lib/ajax';
import moment from 'moment';
import { Store, Module, ActionContext } from 'vuex';
import ReservationList from '../entities/flight/reservation/reservationList';
import ListModule from './list-module';
import ListState from './list-state';

interface ReservationState extends ListState<ReservationList> {
  select: ReservationList;
}

class ReservationModule extends ListModule<
  ReservationState,
  any,
  ReservationList
> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 30,
    list: new Array<ReservationList>(),
    reservationDetail: new Array<ReservationList>(),
    loading: false,
  };

  actions = {
    async getOrders(
      context: ActionContext<ReservationState, any>,
      payload: any
    ) {
      context.state.loading = true;

      if (payload.data.bookingDateStarts == "Invalid date") {
        payload.data.bookingDateStarts = moment();
      }
      if (payload.data.bookingDateEnds == "Invalid date") {
        payload.data.bookingDateEnds = moment();
      }

      const response = await ajax.post(
        '/api/services/app/Agency/GetOrders',
        payload.data
      );
      context.state.loading = false;
      const result = response.data.result.items;
      const count = response.data.result.count;
      context.state.list = result;
      context.state.totalCount = count;
    },
    async getFlightOrders({ state }, payload) {
      state.loading = true;
      const response = await ajax.get(
        '/api/services/app/Booking/GetFlightOrders',
        {
          params: { orderId: payload.data },
        }
      );
      state.reservationDetail = response.data.result.items;
      state.loading = false;
    },
    async sendEmail({ state }, payload) {
      state.loading = true;
      // const response = await ajax.get();
    },
    async cancelOrder({ state }, payload) {
      state.loading = true;
      const response = await ajax.post(
        '/api/services/app/booking/CancelOrder',
        payload.data
      );
      state.loading = false;
      return response;
    },
    async updateBookingPayment({ state }, payload) {
      debugger;
      state.loading = true;
      const response = await ajax.put(
        '/api/services/app/admin/updateBookingPayment',
        payload.data
      );
      state.loading = false;
      return response;
    },


    async approveOrderById({ state }, payload) {
      console.log(payload)
      state.loading = true;
      const response = await ajax.post(
        '/api/services/app/booking/ApproveOrderById',
        { id: payload.data }

      );
      state.loading = false;
      return response;
    },

    async pdfLink({ state }, payload) {

      state.loading = true;
      const response = await ajax.post(
        '/api/services/app/booking/CheckFileOnWasabi?orderId=' + payload.data
      );

      state.loading = false;

      return response.data.result;
    },

    

    async sendTicketEmail({ state }, payload) {
      state.loading = true;
      const response = await ajax.post(
        '/api/services/app/Flight/SendTicketEmail',
        payload.data
      );
      state.loading = false;
      return response;
    },
    async sendTicketEmailForOperation({ state }, payload) {
      state.loading = true;
      const response = await ajax.post(
        '/api/services/app/Flight/SendTicketEmailForOperation',
        payload.data
      );
      state.loading = false;
      return response;
    },
    async saveInvoice({ state }, payload) {
      debugger;
      debugger;
      state.loading = true;
      const response = await ajax.post(
        '/api/services/app/Booking/SaveInvoice?input='+payload.data
      );
      state.loading = false;
      return response;
    },
    async saveRefund({ state }, payload) {
      
      state.loading = true;
      const response = await ajax.post(
        '/api/services/app/Admin/CreateAdditionalPayment'
        ,payload.data
      );
      state.loading = false;
      return response;
    },
  };
}

const reservationModule = new ReservationModule();
export default reservationModule;
